// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3md4O","right":"styles_right___sL4i"};